// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__up9d0","loadingShrink":"PageLoading_loadingShrink__1W1V1"};